/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import ShowVideo from "./show-video";
import { useDispatch, useSelector } from "react-redux";
import { getProfileVideosAction } from "../../../../store/ProfileVideoActions";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { useAxiosInstance } from "../../../../services/Interceptor";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import AddProfileVideoWeightRoom from "./add-video";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import PremiumFeatureModal from "../../../../components/PremiumFeatureModal";
import FreeTrialModal from "../../../../components/FreeTrialModal";
import { StartFreeTrial } from "../../../../services/PaymentService";
import { usePremiumUpsellRedirect } from "../../../../hooks/usePremiumUpsellRedirect";
import { setProfileAction } from "../../../../store/AthleteActions";
import { validateSubscriptionAction } from "../../../../store/userActions";
import { bumpMenuRefresh } from "../../../../store/slices/athleteSlice";

export default function ProfileVideo() {
  const dispatch = useDispatch();
  const r_profileVideo = useSelector((state) => state.profileVideo);
  const auth = useAuthUser();
  const { user = {} } = auth || {};
  const apiInstance = useAxiosInstance();
  const hasSubscription = useSelector((state) => state.user.hasSubscription);
  const hasUsedFreeTrial = useSelector((state) => state.user.hasUsedFreeTrial);
  const hasSubscriptionAccess =
    hasSubscription || user?.role?.toLowerCase?.() === "highschool";
  const showFreeTrial =
    !hasSubscriptionAccess && user?.role === "athlete" && !hasUsedFreeTrial;
  const [isOpen, setIsOpen] = useState(false);
  const [profileVideos, setProfileVideos] = useState([]);
  const [openPremiumFeatureModal, setOpenPremiumFeatureModal] = useState(false);
  const [openTrialModal, setOpenTrialModal] = useState(false);

  useEffect(() => {
    if (!r_profileVideo.reload) {
      dispatch(getProfileVideosAction(apiInstance, auth.user.id));
    }
  }, [dispatch, r_profileVideo.reload]);

  useEffect(() => {
    const results = r_profileVideo.profileVideos.filter(
      (item) => item.type === 6,
    );
    setProfileVideos(results);
  }, [r_profileVideo.profileVideos]);

  const openSubscription = usePremiumUpsellRedirect(user);

  const handlePremiumFreeTrial = () => {
    setOpenPremiumFeatureModal(false);
    setOpenTrialModal(true);
  };

  const handleOpenAdd = () => {
    if (!hasSubscriptionAccess) {
      setOpenPremiumFeatureModal(true);
      return;
    }
    setIsOpen(true);
  };

  return (
    <>
      <ToastContainer />
      <PremiumFeatureModal
        open={openPremiumFeatureModal}
        onClose={() => setOpenPremiumFeatureModal(false)}
        title="Premium Feature"
        description="Adding weight room records is locked. Start a free trial or subscribe now to update your profile."
        onStartFreeTrial={handlePremiumFreeTrial}
        onSubscribe={() => {
          setOpenPremiumFeatureModal(false);
          openSubscription();
        }}
        showStartFreeTrial={showFreeTrial}
      />
      <FreeTrialModal
        open={openTrialModal}
        onClose={() => setOpenTrialModal(false)}
        user={user}
        onStoreSuccessChain={async () => {
          const result = await StartFreeTrial(apiInstance, user.id);
          if (result.success) {
            toast.success("Free trial started!", { position: "top-right" });
            setOpenTrialModal(false);
            await dispatch(setProfileAction(apiInstance, user.id));
            await dispatch(
              validateSubscriptionAction(apiInstance, user.role, user.id),
            );
            dispatch(bumpMenuRefresh());
          } else {
            toast.error("Failed to start free trial", {
              position: "top-right",
            });
          }
        }}
      />
      <div className="relative">
        {r_profileVideo.loading && (
          <div className="absolute top-0 left-0 bg-white/75 w-full h-full pt-24">
            <LoadingSpinner />
          </div>
        )}

        <div className="mt-4">
          <div
            className="float-right text-sm text-white border border-gray-300 p-2 rounded  bg-blue-600 hover:bg-blue-800   cursor-pointer"
            onClick={handleOpenAdd}
          >
            <FontAwesomeIcon icon={faPlus} /> Add new record
          </div>
          <h2 className="font-medium mb-4 uppercase">Weight Room</h2>
          <div className="clear-both"></div>
        </div>
        <div className="clear-both"></div>

        {profileVideos.length > 0 ? (
          <div className="w-full mx-auto border border-blue-700 rounded items-center p-4 mt-2 h-[700px] overflow-auto">
            <div className="w-full mx-auto">
              {profileVideos.map((item, key) => (
                <div
                  key={key}
                  className="odd:bg-[#E6E3E3] flex justify-between items-center p-3 "
                >
                  <span>
                    {item.title} / {item.weight} lbs / {item.reps} reps
                  </span>
                  <>
                    <ShowVideo profileVideo={item} />
                  </>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="bg-blue-100 border border-blue-300 text-blue-800 p-2">
            There are no records to display
          </div>
        )}
      </div>
      <AddProfileVideoWeightRoom
        isOpen={isOpen}
        setIsOpen={() => setIsOpen(false)}
      />
    </>
  );
}
